import client from "./client";

// --- Auth ---
export const login = (username, password) =>
  client.post("/api/auth/login", { username, password }).then((r) => r.data);
export const getMe = () => client.get("/api/auth/me").then((r) => r.data);

// --- Overview / Revenue / Goal ---
export const getOverview = () => client.get("/api/overview").then((r) => r.data);
export const getRevenueSummary = (groupBy = "product", month = "current") =>
  client.get("/api/revenue/summary", { params: { group_by: groupBy, month } }).then((r) => r.data);
export const getRevenueMonths = () => client.get("/api/revenue/months").then((r) => r.data);
export const getGoal = () => client.get("/api/goal").then((r) => r.data);
export const updateGoal = (body) => client.put("/api/goal", body).then((r) => r.data);

// --- Products ---
export const getProducts = () => client.get("/api/products").then((r) => r.data);

// --- Funnel ---
export const getFunnel = (period = "all") =>
  client.get("/api/funnel", { params: { period } }).then((r) => r.data);

// --- Metrics / TikTok ---
export const getMetrics = (period = "all") =>
  client.get("/api/metrics", { params: { period } }).then((r) => r.data);
export const getTiktok = (period = "all") =>
  client.get("/api/tiktok/summary", { params: { period } }).then((r) => r.data);

// --- Hypotheses ---
export const listHypotheses = (status) =>
  client.get("/api/hypotheses", { params: status ? { status } : {} }).then((r) => r.data);
export const createHypothesis = (body) => client.post("/api/hypotheses", body).then((r) => r.data);
export const updateHypothesis = (id, body) =>
  client.put(`/api/hypotheses/${id}`, body).then((r) => r.data);
export const deleteHypothesis = (id) => client.delete(`/api/hypotheses/${id}`).then((r) => r.data);

// --- Board ---
export const getBoard = () => client.get("/api/board").then((r) => r.data);
export const createCard = (body) => client.post("/api/board/cards", body).then((r) => r.data);
export const updateCard = (id, body) => client.put(`/api/board/cards/${id}`, body).then((r) => r.data);
export const deleteCard = (id) => client.delete(`/api/board/cards/${id}`).then((r) => r.data);
export const getCardMetrics = (id) => client.get(`/api/board/cards/${id}/metrics`).then((r) => r.data);

// --- Segments ---
export const getSegments = () => client.get("/api/segments").then((r) => r.data);
export const getPortraits = () => client.get("/api/segments/portraits").then((r) => r.data);
export const createSegment = (body) => client.post("/api/segments", body).then((r) => r.data);
export const updateSegment = (id, body) => client.put(`/api/segments/${id}`, body).then((r) => r.data);
export const deleteSegment = (id) => client.delete(`/api/segments/${id}`).then((r) => r.data);

// --- Settings / course-map ---
export const getCourseMap = () => client.get("/api/settings/course-map").then((r) => r.data);
export const addCourseRule = (body) => client.post("/api/settings/course-map", body).then((r) => r.data);
export const deleteCourseRule = (id) =>
  client.delete(`/api/settings/course-map/${id}`).then((r) => r.data);

// --- Ingest ---
export const refreshIngest = (scope = "all") =>
  client.post("/api/ingest/refresh", null, { params: { scope } }).then((r) => r.data);
export const getIngestStatus = () => client.get("/api/ingest/status").then((r) => r.data);

// --- Кросс-промо экосистемы (переходы из Рублокса) ---
export const getEcoCrosspromo = (days = 90) =>
  client.get("/api/eco-crosspromo", { params: { days } }).then((r) => r.data);
